<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('price.exportPrices') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-prices-export-form" tag="form">
            <p class="text-center mb-0">
                {{ $t('customer.exportPricesInfo') }}
            </p>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="exportInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="exportInProgress"
        @click.prevent="validateForm">
        <div
          v-if="exportInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('price.export') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'customer-prices-export-popup',
  props: {
    customerId: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      exportInProgress: false
    };
  },
  mounted () {
    this.exportInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-prices-export-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-prices-export-form'], this.export);
    },
    export () {
      this.exportInProgress = true;

      this.$http.post('/customers/prices/export/' + this.customerId, null, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$t('price.supplierPricesFileNamePrefix') + this.customerId + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.cancel();
        this.exportInProgress = false;

        Vue.swal({
          title: this.$t('price.exportSuccessfull'),
          html: this.$t('price.exportSuccessfullDesc'),
          type: 'success',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true,
          timer: 2000
        });
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.exportErrorTitle'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.exportInProgress = false;
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
